
<v-row class="no-frame pt-2">
    <v-col class="col-3  no-border pr-2" >
        <div class="stamp-col" v-if="bidStamps">
            <f-stamp-upload
                v-for             = "stamp in bidStamps"
                :key              = "stamp.id"
                :stamp            = "stamp"
                :image            = "getImage (stamp.id)"
                :min-image-height = "120"
                :show-text-input  = "true"
                @drop             = "onDrop"
                @save             = "onSave"
                class             = "upload-frame mb-4"
            />
        </div>
    </v-col>
    <v-col class="col-3 pl-2 pr- 2 no-border " >
        <div class="stamp-col" v-if="invoiceStamps">
            <f-stamp-upload
                v-for             = "stamp in invoiceStamps"
                :key              = "stamp.id"
                :stamp            = "stamp"
                :image            = "getImage (stamp.id)"
                :min-image-height = "120"
                :show-text-input  = "true"
                @drop             = "onDrop"
                @save             = "onSave"
                class             = "upload-frame mb-4"
            />
        </div>
    </v-col>
    <v-col class="col-3 pl-2 pr-2 no-border ">
        <v-row class="no-frame">

        </v-row>
    </v-col>
    <v-col class="col-3 pl-2 no-border ">
        <v-row class="no-frame">
            <p-user-stamps
                v-if="privileged"
            />
        </v-row>
    </v-col>
</v-row>
